<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <v-app>
            <v-container fluid>
              <v-card elevation="2" :loading="loading" outlined>
                <!--                                <v-card-title>-->
                <!--                                    v-if="$can('transaction_create')"-->

                <!--                                    <v-spacer/>-->
                <!--                                    {{ $t($route.meta.title) }}-->
                <!--                                    <v-spacer/>-->

                <!--                                    <v-tooltip bottom>-->
                <!--                                        <template v-slot:activator="{ on, attrs }">-->
                <!--                                            <v-btn :loading="loading" @click="getUserTransactions(transactionUrl)"-->
                <!--                                                   v-bind="attrs"-->
                <!--                                                   v-on="on"-->
                <!--                                                   class="btn-update">-->
                <!--                                                <v-icon>mdi-refresh</v-icon>-->
                <!--                                            </v-btn>-->
                <!--                                        </template>-->
                <!--                                        <span>به روزرسانی تراکنش ها</span>-->
                <!--                                    </v-tooltip>-->

                <!--                                </v-card-title>-->
                <v-divider />
                <!--                <div class="row mb-1">-->
                <!--                  <div class="col-md-4">-->
                <!--                    <select-->
                <!--                        @change="reloadTable1(tableProps)"-->
                <!--                        v-model="tableProps.type"-->
                <!--                        class="form-control">-->
                <!--                      <option value>نوع تراکنش</option>-->
                <!--                      <option value='deposit'>افزایش</option>-->
                <!--                      <option value='withdraw'>کسر</option>-->
                <!--                    </select>-->
                <!--                  </div>-->
                <!--                  <div class="col-md-4">-->
                <!--                    <select-->
                <!--                        @change="reloadTable1(tableProps)"-->
                <!--                        v-model="tableProps.confirmed"-->
                <!--                        class="form-control">-->
                <!--                      <option value>همه ی وضعیت ها</option>-->
                <!--                      <option value='true'>تایید شده</option>-->
                <!--                      <option value='false'>تایید نشده</option>-->
                <!--                    </select>-->
                <!--                  </div>-->
                <!--                  <div class="col-md-4">-->

                <!--                    <date-picker label="تاریخ تراکنش"-->
                <!--                                 v-model="tableProps.date"-->
                <!--                                 v-on:input="reloadTable1(tableProps)"-->
                <!--                                 format="YYYY-MM-DD"-->
                <!--                                 display-format="jYYYY-jMM-jDD"-->

                <!--                    />-->

                <!--                    &lt;!&ndash;                                  <input&ndash;&gt;-->
                <!--                    &lt;!&ndash;                                      name="name"&ndash;&gt;-->
                <!--                    &lt;!&ndash;                                      class="form-control"&ndash;&gt;-->
                <!--                    &lt;!&ndash;                                      placeholder="Search Table">&ndash;&gt;-->
                <!--                  </div>-->
                <!--                </div>-->
                <div class="row">
                  <div class="col-md-12 p-5">
                    <data-table
                      orderDir="desc"
                      :data="transactions"
                      :filters="filters"
                      :columns="columnTransactions"
                      :translate="translate"
                      :per-page="[10, 25, 50, 100, 200, 400]"
                      @on-table-props-changed="reloadTable"
                    >
                      <template
                        slot="filters"
                        slot-scope="{ tableFilters, perPage }"
                      >
                        <div class="row mb-1">
                          <div class="col-md-4">
                            <v-select
                              :items="services"
                              item-text="nameLand"
                              item-value="nameLand"
                              outlined
                              dense
                              label="نوع سرویس"
                              v-model="tableFilters.filters.service"
                            >
                              <template slot="item" slot-scope="{ item }">
                                {{ item.nameLand }}
                              </template>
                            </v-select>
                          </div>
                          <div class="col-md-4">
                            <select
                              v-model="tableFilters.filters.confirmed"
                              class="form-control"
                            >
                              <option value>همه ی وضعیت ها</option>
                              <option value="true">تایید شده</option>
                              <option value="false">تایید نشده</option>
                            </select>
                          </div>
                          <div class="col-md-4">
                            <date-picker
                              label="تاریخ تراکنش"
                              v-model="tableFilters.filters.date"
                              format="YYYY-MM-DD"
                              display-format="jYYYY-jMM-jDD"
                            />
                          </div>
                        </div>
                        <div class="row mb-2">
                          <div class="col-md-4">
                            <v-select
                              v-model="tableFilters.length"
                              :items="perPage"
                              item-value="page"
                              label="تعداد رکورد"
                              item-text="page"
                              outlined
                              dense
                            >
                            </v-select>
                          </div>
                          <div class="col-md-4">
                            <v-select
                              :items="adminTypes"
                              item-text="value"
                              item-value="name"
                              label="نوع"
                              item-disabled="disabled"
                              dense
                              clearable
                              outlined
                              v-model="tableFilters.filters.admin_type"
                            >
                              <template slot="item" slot-scope="{ item }">
                                {{ item.value }}
                              </template>
                            </v-select>
                          </div>
                          <div class="col-md-4">
                            <v-text-field
                              name="name"
                              outlined
                              dense
                              append-icon="search"
                              label="جست وجو"
                              v-model="tableFilters.search"
                              placeholder="جست وجو"
                            ></v-text-field>
                          </div>
                        </div>
                      </template>
                    </data-table>
                  </div>
                </div>
              </v-card>
            </v-container>
          </v-app>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "../../../../core/services/store/breadcrumbs.module";
import transactionBtn from "@/view/pages/admin/transactions/transactionBtn";
import Wallet from "./actions/Wallet";
import Meta from "@/view/pages/transactions/Meta";

export default {
  components: { Wallet },
  data() {
    return {
      services: [],
      dialog: false,
      userWallet: [],
      adminTypes: [
        { name: "online", value: "آنلاین" },
        { name: "admin", value: "توسط مدیر" },
        { name: "refund", value: "تراکنش اصلاحی" },
        { name: "agency", value: "عاملیت", disabled: true },
        { name: "withdraw", value: "برداشت" },
        { name: "deposit", value: "واریز" },
      ],
      filters: {
        type: "",
        admin_type: null,
        service: null,
        confirmed: "",
        date: "",
      },
      transactionUrl: "admin/transactions",
      loading: false,
      transactions: {},
      dialogInfo: null,
      translate: {
        nextButton: "بعدی",
        previousButton: "قبلی",
        rowsPerPageText: "تعداد در صفحه",
        noDataText: "داده ای برای نمایش وجود ندارد",
        placeholderSearch: "جستجو",
      },
      url: "admin/users",
      userInfo: {},
      tableProps: {
        search: "",
        length: 10,
        filters: {
          type: "",
          service: null,
          admin_type: null,
          confirmed: "",
          date: "",
        },
        column: "id",
        dir: "desc",
      },
      columnTransactions: [
        {
          label: "شناسه",
          name: "id",
          orderable: true,
          colStyle: "width: 100px;",
        },
        {
          name: "uuid",
          label: "شناسه پرداخت",
          orderable: true,
        },
        {
          name: "productId",
          label: "شناسه محصول",
          component: Meta,
          meta: {
            type: "productId",
          },
        },
        {
          name: "amount",
          label: "قیمت(﷼)",
          orderable: true,
          transform: (value) => {
            return this.$options.filters.rial(value.data.amount);
          },
        },
        {
          name: "type",
          label: "نوع",
          transform: (value) => {
            return value.data.type === "deposit"
              ? `<span class="badge-pill badge badge-success">افزایش موجودی</span>`
              : `<span class="badge-pill badge badge-danger">کسر موجودی</span>`;
          },
        },
        {
          name: "confirmed",
          label: "وضعیت",
          transform: (value) => {
            return value.data.confirmed === true
              ? `<span class="badge-pill badge badge-info">تایید شده</span>`
              : `<span class="badge-pill badge badge-danger">رد شده</span>`;
          },
        },

        {
          name: "created_at",
          label: "تاریخ",
          orderable: true,
          transform: (value) => {
            return this.$options.filters.longDate(value.data.created_at);
          },
        },
        {
          name: "admin_type",
          label: "نوع پرداختی",
          orderable: true,
          transform: ({ data }) => {
            return this.$options.filters.adminType(data.admin_type);
          },
        },
        {
          name: "comment",
          label: "توضیح",
          component: Meta,
          meta: {
            type: "comment",
          },
        },
        {
          name: "actions",
          label: "عملیات",
          component: Meta,
          meta: {
            type: "actions",
          },
        },
        {
          name: "service",
          label: "نام سرویس",
          component: Meta,
          meta: {
            type: "service",
          },
        },
        {
          label: "عملیات",
          name: "action",
          component: transactionBtn,
          handler: this.actions,
          event: "action",
          meta: {
            permission_prefix: "adminTransaction_",
          },
        },
      ],
    };
  },
  async created() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: this.$route.meta.title }]);
    this.getUserTransactions(this.transactionUrl);
    try {
      this.services = await this.getService();
    } catch (error) {
      console.error("Failed to fetch services:", error);
      this.$toast.error("خطا در دریافت سرویس‌ها");
    } finally {
    }
  },

  methods: {
    filterOnlyCapsText(value, search, item) {
      return (
        value != null &&
        search != null &&
        typeof value === "string" &&
        value.toString().toLocaleUpperCase().indexOf(search) !== -1
      );
    },

    getUserTransactions(url = this.transactionUrl, params = this.tableProps) {
      this.loading = true;
      if (params.search === null) this.$modal.showLoading();
      this.requestApiGet(this.transactionUrl, params)
        .then((response) => {
          this.transactions = response.data;
          this.loading = false;
          this.$modal.hideLoading();
        })
        .catch(({ response }) => {
          this.$modal.hideLoading();
          this.loading = false;
        });
    },
    reloadTable(tableProps) {
      this.getUserTransactions(this.transactionUrl, tableProps);
    },
    reloadTable1(tableProps) {
      this.getUserTransactions(this.transactionUrl, tableProps);
    },
    updateValue() {
      this.reloadTable1(this.transactionUrl, tableProps);
    },
    actions(data, type) {
      this[type](data);
    },
    edit(data) {
      this.$router.push({
        name: "admin.transactions.show",
        params: { id: data.id },
      });
    },
    information(data) {
      this.$router.push({
        name: "admin.transactions.show",
        params: { id: data.id },
      });
    },
  },
};
</script>
